import { render, staticRenderFns } from "./login-form.vue?vue&type=template&id=0e5dd152&"
import script from "./login-form.component.ts?vue&type=script&lang=ts&"
export * from "./login-form.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports